import React, { useEffect, useState } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/font-awesome.min.css';
import '../assets/css/fontawesome-stars-o.min.css';
import '../assets/css/responsive-style.css';
import '../assets/css/colors/theme-color-1.css';
import '../assets/css/custom.css';
import '../assets/css/home.css';
import '../assets/css/owl.carousel.min.css';

const Contact = () => {
  const [contactInfo, setContactInfo] = useState({
    address: "",
    phone: "",
    email: "",
    city: "",
    state: "",
    country: "",
    zipCode: ""
  });
  const [loading, setLoading] = useState(true);

  const newsItems = [
    "Contrary to popular belief Lorem Ipsum is not simply random text.",
    "Education to popular belief Lorem Ipsum is not simply",
    "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    "Corporis repellendus perspiciatis reprehenderit.",
    "Deleniti consequatur laudantium sit aspernatur?"
  ];

  useEffect(() => {
    const fetchContactInfo = async () => {
      let data = {}; // Initialize data object outside try block
      
      try {
        const response = await fetch('http://localhost:5000/api/settings/');
        data = await response.json();
        
        // Create full address string
        const fullAddress = `${data.address}, ${data.city}, ${data.state}, ${data.country}, ${data.zipCode}`;
        
        // Geocode the address to get coordinates
        const geocoder = new window.google.maps.Geocoder();
        const geocodeResult = await new Promise((resolve, reject) => {
          geocoder.geocode({ address: fullAddress }, (results, status) => {
            if (status === 'OK') {
              resolve(results[0].geometry.location);
            } else {
              reject(new Error('Geocode was not successful: ' + status));
            }
          });
        });

        setContactInfo({
          address: data.address,
          phone: data.contactNo,
          email: data.email,
          city: data.city,
          state: data.state,
          country: data.country,
          zipCode: data.zipCode
        });
      } catch (error) {
        console.error('Error:', error);
        // Fallback to default coordinates if geocoding fails
        setContactInfo({
          address: data.address || "Nashik",
          phone: data.contactNo,
          email: data.email,
          city: data.city || "Nashik",
          state: data.state || "Maharashtra",
          country: data.country || "India",
          zipCode: data.zipCode || "422001"
        });
        
        // Use geocoding for default location (Nashik)
        try {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ address: "Nashik, Maharashtra, India" }, (results, status) => {
            if (status === 'OK' && results[0]) {
              const location = results[0].geometry.location;
              initMap(location.lat(), location.lng());
            } else {
              // If geocoding fails, use hardcoded coordinates for Nashik
              initMap(19.9975, 73.7898);
            }
          });
        } catch (geoError) {
          console.error('Geocoding error:', geoError);
          // Hardcoded coordinates for Nashik
          initMap(19.9975, 73.7898);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();

    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps) {
      initMap();
      return;
    }

    // Load Google Maps API only if not already loaded
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBK9f7sXWmqQ1E-ufRXV3VpXOn_ifKsDuc&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      initMap();
    };
    document.head.appendChild(script);

return () => {
      // Clean up the script when component unmounts
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, []);

  {/* Map Start */}
  <div 
    className="map--fluid mtop--30" 
    id="map" 
    data-map-latitude={contactInfo.latitude}
    data-map-longitude={contactInfo.longitude}
    data-map-zoom={16}
  />
  {/* Map End */}
  
  const initMap = (lat, lng) => {
    const mapElement = document.getElementById('map');
    if (!mapElement) return;
  
    const latitude = lat || parseFloat(mapElement.dataset.mapLatitude) || 19.9975; // Default to Nashik
    const longitude = lng || parseFloat(mapElement.dataset.mapLongitude) || 73.7898;
    const zoom = parseInt(mapElement.dataset.mapZoom) || 14;
  
    const map = new window.google.maps.Map(mapElement, {
      center: { lat: latitude, lng: longitude },
      zoom: zoom
    });
  
    // Create marker
    const marker = new window.google.maps.Marker({
      position: { lat: latitude, lng: longitude },
      map: map
    });
  
    // Add info window with full address details
    const infoWindow = new window.google.maps.InfoWindow({
      content: `
        <div style="padding: 10px;">
          <h3 style="margin-bottom: 5px;">Our Location</h3>
          <p style="margin: 0;">
            ${contactInfo.address || 'nanded maharastra'}, 
            ${contactInfo.city || 'nanded'}, 
            ${contactInfo.state || 'Maharashtra'}, 
            ${contactInfo.country || 'India'} - 
            ${contactInfo.zipCode || '431617'}
          </p>
        </div>
      `
    });
    
    // Open info window by default
    infoWindow.open(map, marker);
    
    // Add click event to show info window
    marker.addListener('click', () => {
      infoWindow.open(map, marker);
    });
  };

return (
    <div>
      {/* Wrapper Start */}
      <div className="wrapper">
    
    {/* Posts Filter Bar Start */}
    <div className="posts--filter-bar style--1 hidden-xs">
      <div className="container">
        <ul className="nav">
          <li>
            <a href="#">
              <i className="fa fa-star-o" />
              <span>Featured News</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-heart-o" />
              <span>Most Popular</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-fire" />
              <span>Hot News</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-flash" />
              <span>Trending News</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-eye" />
              <span>Most Watched</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    {/* Posts Filter Bar End */}
    {/* News Ticker Start */}
    <div className="news--ticker">
      <div className="container">
        <div className="title">
          <h2>News Updates</h2>
          <span>(Update 12 minutes ago)</span>
        </div>
        <div className="news-updates--list" data-marquee="true">
          <ul className="nav">
            {newsItems.map((item, index) => (
              <li key={index}>
                <h3 className="h3"><a href="#">{item}</a></h3>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    {/* News Ticker End */}
    {/* Main Breadcrumb Start */}
    <div className="main--breadcrumb">
      <div className="container">
        <ul className="breadcrumb">
          <li><a href="home-1.html" className="btn-link"><i className="fa fm fa-home" />Home</a></li>
          <li className="active"><span>Contact</span></li>
        </ul>
      </div>
    </div>
    {/* Main Breadcrumb End */}
    {/* Map Start */}
    <div 
      className="map--fluid mtop--30" 
      id="map" 
      data-map-latitude="19.9975" 
      data-map-longitude="73.7898" 
      data-map-zoom={14}
    />
    {/* Map End */}
    {/* Contact Section Start */}
    <div className="content">
  <div className="container">
    <div className="row">
      <div className="col-md-5 mr-auto">
        <h1>Contact Us</h1>
        <p className="mb-5">
        "Have questions, feedback, or need assistance? We’re here to help! Whether you’re looking for support, business inquiries, or collaboration opportunities, feel free to reach out. Our team is always ready to assist you and ensure you have the best experience with us. Get in touch today, and we’ll be happy to assist you!"
        </p>

        <ul className="list-unstyled pl-md-5 mb-5">
          <li className="d-flex text-black mb-2">
            <span className="mr-3"><span className="icon-map"></span></span> 
            {loading ? 'Loading address...' : (
              `${contactInfo.address || 'nanded maharastra'}, ${contactInfo.city || 'nanded'}, ${contactInfo.state || 'Maharashtra'}, ${contactInfo.country || 'India'} - ${contactInfo.zipCode || '431617'}`
            )}
          </li>
          <li className="d-flex text-black mb-2">
            <span className="mr-3"><span className="icon-phone"></span></span> 
            {loading ? 'Loading phone...' : (contactInfo.contactNo || '+917822884053')}
          </li>
          <li className="d-flex text-black">
            <span className="mr-3"><span className="icon-envelope-o"></span></span> 
            {loading ? 'Loading email...' : (contactInfo.email || 's21_govindwar_soham@mgmcen.ac.in')}
          </li>
        </ul>
      </div>

          <div className="col-md-6">
            <form 
              className="mb-5" 
              method="post" 
              id="contactForm" 
              name="contactForm"
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '25px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                backgroundColor: '#fff'
              }}
            >
              <div className="row">
                <div className="col-md-12 form-group">
                  <label htmlFor="name" className="col-form-label">Name</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    name="name" 
                    id="name"
                    placeholder="Enter your name"
                    style={{
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '10px 15px',
                      width: '100%',
                      fontSize: '16px',
                      transition: 'border-color 0.3s ease'
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 form-group">
                  <label htmlFor="email" className="col-form-label">Email</label>
                  <input 
                    type="email" 
                    className="form-control" 
                    name="email" 
                    id="email"
                    placeholder="Enter your email"
                    style={{
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '10px 15px',
                      width: '100%',
                      fontSize: '16px',
                      transition: 'border-color 0.3s ease'
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 form-group">
                  <label htmlFor="phone" className="col-form-label">Phone Number</label>
                  <input 
                    type="tel" 
                    className="form-control" 
                    name="phone" 
                    id="phone"
                    placeholder="Enter your phone number"
                    style={{
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '10px 15px',
                      width: '100%',
                      fontSize: '16px',
                      transition: 'border-color 0.3s ease'
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 form-group">
                  <label htmlFor="message" className="col-form-label">Message</label>
                  <textarea 
                    className="form-control" 
                    name="message" 
                    id="message" 
                    cols="30" 
                    rows="7"
                    placeholder="Enter your message"
                    style={{
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '10px 15px',
                      width: '100%',
                      fontSize: '16px',
                      transition: 'border-color 0.3s ease'
                    }}
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <input type="submit" value="Send Message" className="btn btn-primary rounded-0 py-2 px-4" />
                  <span className="submitting"></span>
                </div>
              </div>
            </form>

            <div id="form-message-warning mt-4"></div> 
            <div id="form-message-success">
              Your message was sent, thank you!
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Contact Section End */}
    
  </div>
  {/* Wrapper End */}
  {/* Back To Top Button Start */}
  <div id="backToTop">
    <a href="#"><i className="fa fa-angle-double-up" /></a>
  </div>
 </div>

  );
};

export default Contact;